import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-saledeed',
  templateUrl: './saledeed.component.html',
  styleUrls: ['./saledeed.component.css']
})
export class SaledeedComponent implements OnInit {
title="SaleDeed"
title1="Installment"
title2="Schedule of Property"

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/saledeed/saledeed.component.ts